import SmartLink from '../../lib/includes/components/component.smartlink';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import React, {useEffect, useRef} from "react";
import {useState} from "react";

import LogoUrl from './../../assets/img/logo.svg';

import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faBars, faXmark} from "@fortawesome/pro-light-svg-icons";
import MaterialButton from "./component.materialButton";

import LogoUrlSkill from './../../assets/img/logo_skill.svg';
import LogoUrlExecutive from './../../assets/img/logo_executive.svg';
import LogoUrlAcademy from './../../assets/img/logo_academy.svg';

import gsap from "gsap";
import { useGSAP } from '@gsap/react';


const Header = (props) => {


	if (!props.general) {
		return null;
	}


	const popup_company_1 = useRef(null);
	const popup_company_2 = useRef(null);
	const popup_company_3 = useRef(null);

	const [companiesToggled, setCompaniesToggled] = useState(false);


	const popup = useRef();

	const { contextSafe } = useGSAP({ scope: popup });


	const onClickSafe = contextSafe(() => {

		setCompaniesToggled(!companiesToggled);


		gsap.from(".company1", {
			y: "50",
			opacity: 0,
			duration: .5,
			delay: 0.05,
			ease: "power1.out"
		});
		gsap.from(".company2", {
			y: "50",
			opacity: 0,
			duration: .5,
			delay: 0.1,
			ease: "power1.out"
		});
		gsap.from(".company3", {
			y: "50",
			opacity: 0,
			duration: .5,
			delay: 0.15,
			ease: "power1.out"
		});


	});



	return <header className="site-header">
		<div className="container">
			<div className="site-header-content">

			<Link to="/" className="logo">
				<img src={LogoUrl} alt={props.general.title} />
			</Link>

			<div className={"site-navigation" + (props.menu.menu_toggled ? " open" : "")}>
				{props.menu.menus.main_menu &&
					<ul>
						{props.menu.menus.main_menu.items.filter(item => item.parent == 0).map((item, i) => {
							return <li key={item.id}>
								<SmartLink activeClassName="current" url={item.url} target={item.target}>{item.title}</SmartLink>
							</li>
						})}
					</ul>
				}
				<div className="d-lg-none" onClick={() => {
					setCompaniesToggled(!companiesToggled);
				}}><MaterialButton>Våra bolag</MaterialButton></div>
			</div>


				<div className="">

					<div className="d-none d-lg-block" onClick={onClickSafe}><MaterialButton>Våra bolag</MaterialButton></div>


					<button className={"hamburger d-lg-none " + (props.custom.menu_toggled ? " checked" : "")} onClick={props.toggleMenu}>
						<span></span>
						<span></span>
						<span></span>
					</button>


				</div>
			</div>

		</div>



			<div className={companiesToggled ? "popUp" : "popUp d-none" } role="dialog">

				<div className="modal-bg" onClick={() => {
					setCompaniesToggled(false);
				}}></div>
				<div>
					<div className="popUpOuter">


						<div className="text-center d-lg-none"><button type="button" className="close" onClick={() => {
							setCompaniesToggled(false);
						}} data-dismiss="modal" aria-label="Close">
							<span>Stäng</span>
						</button>
						</div>


						<div className="container">
						<div className="company-wrapper" ref={popup}>
						<div className="company company1">
							<div className="content">
								<div>

									<img src={LogoUrlSkill} className="company-logo" />
									{props.general.companies.skill_information &&
										<p>{props.general.companies.skill_information}</p>
									}


								</div>

								{props.general.companies.skill_link &&
									<SmartLink url={props.general.companies.skill_link} target="_blank" className={"btn"}>Besök</SmartLink>
								}
							</div>
						</div>

						<div className="company company2">
							<div className="content">
								<div>
									<img src={LogoUrlExecutive} className="company-logo" />

									{props.general.companies.skill_executive_information &&
										<p>{props.general.companies.skill_executive_information}</p>
									}

								</div>

								{props.general.companies.skill_executive_link &&
									<SmartLink url={props.general.companies.skill_executive_link} target="_blank" className={"btn"}>Besök</SmartLink>
								}
							</div>
						</div>

						<div className="company company3" ref={popup_company_3}>
							<div className="content">
								<div>

									<img src={LogoUrlAcademy} className="company-logo" />
									{props.general.companies.skill_academy_information &&
										<p>{props.general.companies.skill_academy_information}</p>
									}



								</div>

								{props.general.companies.skill_academy_link &&
									<SmartLink url={props.general.companies.skill_academy_link} target="_blank" className={"btn"}>Besök</SmartLink>
								}
							</div>
						</div>
						</div>
						</div>


						<div className="text-center d-none d-lg-block"><button type="button" className="close" onClick={() => {
							setCompaniesToggled(false);
						}} data-dismiss="modal" aria-label="Close">
							<span>Stäng</span>
						</button>
						</div>



					</div>
				</div>
			</div>




	</header>
};
export default connect(
	state => {
		return {
			menu: state.menuState,
			general: state.generalState.general,
			custom: state.customState
		}
	},
	(dispatch) => {
		return {
			toggleMenu: () => {
				dispatch({
					type: 'MENU_TOGGLED'
				})
			},
		}
	}
)(Header);
